import Vue from "vue";
import {
  CompanyFilterService,
  CountryService,
  DocumentTypeService,
  documentTypesMixin,
  GeolocationService,
  JobService,
  PurposeTripService,
  RegionService,
  ReservationService,
  TransportTypeService,
  validationMixin
} from "smck-service";

import {
  CreditCard,
  FormMixin,
  SignaturePad,
  zDatePicker,
  zFlagNumber,
  zSignatureValidationGuestModal,
  zSignatureModalWarningBack
} from "zoox-components";
import CompanyService from "@/service/company-service";
import CountryServiceLocal from "@/service/country-service";
import {
  ApiClient,
  CustomHeadersService,
  FlashMessageService,
  Helper
} from "zoox-infra";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import SignatureEditBtn from "@/components/shared/SignatureEditBtn";
import { find } from "lodash";
import throttle from "lodash/throttle";
import ReservationDataHeader from "@/components/shared/ReservationDataHeader";
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
  name: "Signaturev2",
  mixins: [sessionMixin, FormMixin, validationMixin, documentTypesMixin],
  components: {
    SignaturePad,
    CreditCard,
    ReservationDataHeader,
    SignatureEditBtn,
    "z-signature-modal-warning-back": zSignatureModalWarningBack,
    "z-date-picker": zDatePicker,
    "z-flag-number": zFlagNumber,
    "z-signature-validation-modal": zSignatureValidationGuestModal
  },
  props: {
    fieldSettingsData: {
      type: Object
    },
    reservation: {
      type: Object
    },
    companyName: {
      type: String
    },
    enableRecognition: {
      type: Boolean
    },
    mustFinalize: {
      type: Boolean,
      default: true
    },
    enableZooxpay: {
      type: Boolean,
      default: false
    },
    hasChargeToPayAtCheckin: {
      type: Boolean,
      default: false
    },
    orientationTexts: {
      type: Object
    },
    isMaster: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showWarningBackScreenModal: false,
      showNextGuestModal: false,
      hasClickedEditButton: false,
      reservationService: new ReservationService(),
      companyService: new CompanyService(),
      countryService: new CountryService(),
      countryServiceLocal: new CountryServiceLocal(),
      companyFilterService: new CompanyFilterService(Vue),
      panel: [],
      fnrhData: {},
      purposesTripFull: [],
      jobsFull: [],
      searchJob: null,

      jobService: new JobService(Vue),
      geolocationService: new GeolocationService(Vue),
      regionService: new RegionService(Vue),

      transportTypesFull: [],
      purposeTripService: new PurposeTripService(Vue),
      transportTypeService: new TransportTypeService(Vue),
      apiClient: new ApiClient(),
      documentTypeService: new DocumentTypeService(Vue),
      guestsUnfinalized: [],
      loading: false,
      // currentGuest: {},
      nextCityName: "",
      arrivingCityName: "",

      zipItems: [],
      searchZip: null,
      canShow: false,
      genders: [
        { value: "M", name: this.$t("GLOBAL.GENDER_MALE") },
        { value: "F", name: this.$t("GLOBAL.GENDER_FEMALE") }
      ],
      showConfirmationModal: false,
      radioGroupSelectValidationModel: null,
      radioGroupSelectValidationLabels: [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ],
      guestComunicationOptions: null,
      validationModalStep: 0,
      validationCode: null,
      backupGuest: null,
      needSignature: false
    };
  },
  created() {
    document.addEventListener("beforeunload", this.handlerClose);
  },
  watch: {
    searchZip: function(value) {
      if (
        value &&
        ((value.includes("-") && value.length >= 9) || value.length >= 8) &&
        !this.preventCombosFill
      ) {
        const zipRegex = /[0-9]{5}-[\d]{3}/;

        let searchTerm = "";

        // Formata a busca para API

        if (zipRegex.test(value)) {
          searchTerm = value;
        } else {
          if (value.includes("-")) {
            searchTerm = value;
          } else {
            searchTerm = value.substr(0, 5) + "-" + value.substr(5, 10);
          }
        }

        this.searchCountriesByZip(searchTerm);
      } else if (this.zipItems.length !== 0) {
        // Faz nada
        this.zipItems = [];
      } else {
        this.zipItems = [];
      }
    },
    reservation: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.reservation = value;
        if (this.reservation && this.reservation.guests) {
          this.currentGuest = find(
            this.reservation.guests,
            g => g.id === this.$route.params.guestId
          );
        }
      }
    },
    searchJob: async function(value) {
      await this.jobService.getAll(value).then(resp => {
        this.jobsFull = resp;
      });
    }
  },
  computed: {
    ...mapState({
      currentReservation: "currentReservation",
      isQualifiedGuest: "isQualifiedGuest",
      currentGuest: "currentGuest"
    }),
    personalDataContentTranslation() {
      return this.countryService.contentTranslation(
        this.orientationTexts.personalData,
        this.$i18n.locale
      );
    },
    getFullNextDestination() {
      const nextDestination = [];
      if (this.currentGuest.nextDestinationCountryId) {
        nextDestination.push(this.currentGuest.nextDestinationCountryId);
      }
      if (this.currentGuest.nextDestinationStateName) {
        nextDestination.push(this.currentGuest.nextDestinationStateName);
      }
      if (this.nextCityName) {
        nextDestination.push(this.nextCityName);
      }

      return nextDestination.join(" - ");
    },
    getFullArrivingFrom() {
      const arrivingFrom = [];
      if (this.currentGuest.arrivingFromCountryId) {
        arrivingFrom.push(this.currentGuest.arrivingFromCountryId);
      }
      if (this.currentGuest.arrivingFromStateName) {
        arrivingFrom.push(this.currentGuest.arrivingFromStateName);
      }
      if (this.arrivingCityName) {
        arrivingFrom.push(this.arrivingCityName);
      }

      return arrivingFrom.join(" - ");
    },
    guestId() {
      return this.$route.params.guestId;
    },
    reservationId() {
      return this.$route.params.reservationId;
    }
  },
  async mounted() {
    if (
      this.currentGuest.ddd == null ||
      this.currentGuest.phoneNumber == null
    ) {
      this.currentGuest.ddd = "";
      this.currentGuest.phoneNumber = "";
    }
    Vue.$globalEvent.$on("languageChanged", () => {
      this.radioGroupSelectValidationLabels = [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ];
    });
    document.getElementById("sectionSignature").scrollIntoView();
    const company = this.companyService.getLocalCompany();
    this.companyService.getFnrhFormSettings(company.id).then(resp => {
      this.companyParams = resp;
      this.needSignature = this.companyParams.mandatorySignature;
    });

    await this.purposeTripService.getAll().then(resp => {
      this.purposesTripFull = resp.data;
    });

    await this.transportTypeService.getAll().then(resp => {
      this.transportTypesFull = resp.data;
    });

    await this.jobService.getAll(this.currentGuest.jobName).then(resp => {
      this.jobsFull = resp;
    });

    let nextName = "";
    if (this.currentGuest.nextDestinationCityName) {
      nextName = this.currentGuest.nextDestinationCityName;
    } else if (this.currentGuest.nextDestinationName) {
      nextName = this.currentGuest.nextDestinationName;
    }
    if (
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
        nextName
      )
    ) {
      this.countryServiceLocal.getCityById(nextName).then(resp => {
        if (resp && resp.name) {
          this.nextCityName = resp.name;
        }
      });
    } else {
      this.nextCityName = nextName;
    }

    let arrivingName = "";
    if (this.currentGuest.arrivingFromCityName) {
      arrivingName = this.currentGuest.arrivingFromCityName;
    } else if (this.currentGuest.arrivingFromName) {
      arrivingName = this.currentGuest.arrivingFromName;
    }
    if (
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
        arrivingName
      )
    ) {
      this.countryServiceLocal.getCityById(arrivingName).then(resp => {
        if (resp && resp.name) {
          this.arrivingCityName = resp.name;
        }
      });
    } else {
      this.arrivingCityName = arrivingName;
    }

    this.currentGuest.ota = this.reservation.guests[0].ota;

    if (this.currentGuest.zipCode) {
      this.zipItems = this.zipItems.concat({
        zipCode: this.currentGuest.zipCode,
        value: this.currentGuest.zipCode
      });
    }

    const reservation = this.reservationService.getLocalReservation();
    let guest = reservation.guests.find(
      x => x.id === this.$route.params.guestId
    );

    this.guestComunicationOptions = [
      {
        type: "email",
        value: guest.email,
        id: guest.emailId
      },
      {
        type: "phone",
        value: guest.mobilePhoneNumber,
        id: guest.mobilePhoneNumberId
      }
    ];

    this.backupGuest = { ...this.currentGuest };

    this.$_gtagPlugin_trackEvent("ENTERED_SIGNATURE", "PORTAL", this.guestId);
  },
  methods: {
    ...mapActions([
      "$setCurrentReservation",
      "$setCurrentGuest",
      "$setIsBackingStep"
    ]),
    arrivingFromData: function() {
      return (
        !this.fieldSettingsData.arrivingFromCountryData ||
        !this.fieldSettingsData.arrivingFromStateData ||
        !this.fieldSettingsData.arrivingFromCityData
      );
    },
    nextDestinationData: function() {
      return (
        !this.fieldSettingsData.nextDestinationCountryData ||
        !this.fieldSettingsData.nextDestinationStateData ||
        !this.fieldSettingsData.nextDestinationCityData
      );
    },
    selectZip(selection) {
      this.currentGuest.addressNumber = "";
      this.currentGuest.addressComplement = "";
      if (selection) {
        this.currentGuest.cityId = selection.cityId;
        this.currentGuest.cityName = selection.cityName;
        this.currentGuest.stateName = selection.stateName;
        this.currentGuest.stateId = selection.stateId;
        this.currentGuest.zipCode = selection.zipCode;
        this.currentGuest.address = selection.route;
        this.currentGuest.neighborhood = selection.neighborhood;
        this.currentGuest.addressComplement = selection.complement;
      }

      this.fillStates();
      this.fillCities();
    },
    fillStates() {
      return this.getStates("", this.currentGuest.countryId).then(data => {
        this.stateItems = data;
      });
    },
    fillCities() {
      return this.getCities("", this.currentGuest.stateId).then(data => {
        this.cityItems = data;
      });
    },
    async resendCode(value) {
      return this.sendCode(value);
    },
    async sendCode(value) {
      if (value) {
        return this.apiClient
          .post(`v2/portal/send-code`, {
            contactId: value.id,
            reservationNumber: this.currentReservation.reservationNumber
          })
          .then(resp => {
            if (resp.ok) {
              this.validationModalStep = 2;
            }
          });
      }
    },
    async checkValidationCode(value) {
      if (value.code && value.code.length === 5) {
        try {
          this.loading = true;
          const resp = await this.apiClient.post(
            `portal/verify-code`,
            {
              contactId: value.contactId,
              verificationCode: value.code
            },
            null,
            false,
            true
          );

          if (resp.token) {
            this.showValidationModal = false;
            this.alreadyAuthenticated = true;
            CustomHeadersService.setCustomHeaders({
              Authorization: resp.token
            });
            let currentGuestWithPersonId = { ...this.currentGuest };
            currentGuestWithPersonId.personId = resp.personId;

            this.$setCurrentGuest(currentGuestWithPersonId);
            this.$emit("update-vuex-guest", currentGuestWithPersonId);
            await this.reservationService.sendWelcomeMail();
            this.finalizeWithouValidation();
          }
        } catch (error) {
          if (error.status === 401) {
            FlashMessageService.error(this.$t("NOVO_FLUXO.INCORRECT_PIN"));
          } else {
            FlashMessageService.error(this.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN"));
          }
        } finally {
          this.loading = false;
        }
      }
    },
    fillCombosData: throttle(async function() {
      if (this.preventCombosFill) {
        return;
      }

      this.startLongLoading();
      this.preventCombosFill = true;

      return Promise.all([
        this.findCountry("", "residenceCountryItems"),
        this.findCountry("", "nationalityItems"),
        this.jobService.getAll(this.currentGuest.jobName),
        this.searchCountriesByZip(this.currentGuest.zipCode),
        this.fillStates(),
        this.fillCities(),
        this.purposeTripService.getAll(),
        this.transportTypeService.getAll()
      ]).then(([jobsResponse, purposeTripResponse, transportTypeResponse]) => {
        this.setDefaultDDIs(this.residenceCountryItems);
        this.jobItems = jobsResponse;
        this.purposesTripFull = purposeTripResponse.data;
        this.transportTypesFull = transportTypeResponse.data;
        this.zipItems = this.zipItems.concat({
          zipCode: this.currentGuest.zipCode,
          value: this.currentGuest.zipCode
        });

        this.stopLongLoading();
        this.preventCombosFill = false;
      });
    }, 500),
    addZip() {
      if (
        this.currentGuest.zipCode !== this.searchZip &&
        !this.companyParams.zipValidation
      ) {
        this.currentGuest.addressNumber = "";
        this.currentGuest.addressComplement = "";

        this.cityItems = [];
        this.stateItems = [];

        this.currentGuest.cityName = "";
        this.currentGuest.stateName = "";

        this.currentGuest.address = "";
        this.currentGuest.neighborhood = "";
        this.currentGuest.addressComplement = "";
        this.currentGuest.zipCode = "";

        this.currentGuest.zipCode = this.searchZip;

        this.zipItems = this.zipItems.concat({
          zipCode: this.searchZip,
          value: this.searchZip
        });
      }
    },
    searchCountriesByZip: function(filter = "", skipLoading = false) {
      const $context = this;

      if (
        !filter ||
        (!skipLoading && $context.loading && !this.preventCombosFill)
      )
        return;
      $context.loading = true;

      return $context.geolocationService
        .geocodeAddress(
          filter,
          $context.currentGuest.countryId,
          $context.currentLang || ($context.$i18n && $context.$i18n.locale)
        )
        .then(resp => {
          if (resp.length === 0 && filter.length > 5) {
            $context.searchCountriesByZip(filter.substr(0, 5), true);
          } else {
            $context.zipItems = resp;
          }
        })
        .catch(() => {
          $context.zipItems = [];
        })
        .finally(() => {
          $context.loading = false;
        });
    },
    getPurposeTripData: function(guest, locale) {
      return this.purposesTripFull.reduce((acc, nxt) => {
        return nxt.id === guest.purposeTrip
          ? nxt[`name_${locale}`] || nxt.name
          : acc;
      }, "");
    },
    jobSelect(data) {
      if (data && data.name && data._id) {
        this.currentGuest.jobName = data.name;
        this.currentGuest.jobId = data._id;
      } else if (typeof data === "string") {
        this.currentGuest.jobId = null;
      }
    },
    getTransportTypeData: function(guest, locale) {
      return this.transportTypesFull.reduce((acc, nxt) => {
        return nxt.id === guest.arrivingBy
          ? nxt[`name_${locale}`] || nxt.name
          : acc;
      }, "");
    },
    checkIsMinor() {
      const MIN_AGE = 18;
      const DIFF_VALUE = "years";
      const { id: guestId, birthdate } = this.currentGuest;
      const isChild =
        !!birthdate && moment().diff(birthdate, DIFF_VALUE) < MIN_AGE;
      localStorage.age = JSON.stringify({ isChild, guestId });
      return isChild;
    },
    checkComum() {
      return (
        this.currentGuest.birthdate &&
        this.currentGuest.countryId &&
        this.currentGuest.documentNumber &&
        this.currentGuest.zipCode &&
        this.currentGuest.stateName &&
        this.currentGuest.cityName &&
        this.currentGuest.address &&
        this.currentGuest.addressNumber &&
        this.currentGuest.neighborhood
      );
    },
    validateConfirmEdit() {
      if (this.$refs.editGuestForm.validate()) {
        this.checkIsMinor();
        const isChild = JSON.parse(localStorage.age).isChild;

        if (
          this.checkComum() &&
          (isChild ||
            (this.currentGuest.email &&
              this.currentGuest.jobName &&
              this.currentGuest.mobilePhoneNumber))
        ) {
          this.canShow = false;
          this.updateResGuest();
        }
      }
    },
    getPhotoUrl: function(guest) {
      return (
        guest.photoUrl || require("../../../assets/images/generic-user.jpg")
      );
    },
    getFullAddress: function(guest) {
      let address = "";

      if (guest.address) {
        address += guest.address;
      }

      if (guest.addressNumber) {
        address += `, ${guest.addressNumber}`;
      }

      if (guest.addressComplement) {
        address += ` - ${guest.addressComplement}`;
      }

      if (guest.neighborhood) {
        address += `, ${guest.neighborhood}`;
      }

      if (guest.zipCode) {
        address += `, ${guest.zipCode}`;
      }

      if (guest.cityName) {
        address += ` - ${guest.cityName}`;
      }

      if (guest.stateName) {
        address += ` - ${guest.stateName}`;
      }

      if (guest.countryName) {
        address += ` - ${guest.countryName}`;
      }

      return address;
    },
    getLandPhoneNumber: function(guest) {
      if (guest.ddi && guest.phoneNumber && guest.phoneMask) {
        return `+${guest.ddi} ${Helper.maskString(
          guest.ddd + guest.phoneNumber,
          guest.phoneMask,
          { "#": /\d/ }
        )}`;
      }
      return "";
    },
    getPhoneNumber: function(guest) {
      if (
        guest.mobileCountryCode &&
        guest.mobilePhoneNumber &&
        guest.mobilePhoneMask
      ) {
        return `+${
          guest.mobileCountryCode
        } ${Helper.maskString(
          guest.mobileCityCode + guest.mobilePhoneNumber,
          guest.mobilePhoneMask,
          { "#": /\d/ }
        )}`;
      }
      return "";
    },
    editGuest: function(guest, isOtherInfo) {
      this.$router.push({
        name: "Home",
        params: {
          reservationId: this.reservationId,
          guestId: guest.id
        }
      });

      isOtherInfo == true
        ? Vue.$globalEvent.$emit("tabChange", 1)
        : Vue.$globalEvent.$emit("tabChange", 0);

      this.$setCurrentMobileStep(1);
    },
    getFullName: function(guest) {
      return `${guest.name} ${guest.lastName}`;
    },
    clear: function() {
      this.currentGuest.signature = "";
      this.currentGuest.signatureUrl = null;
      this.updateResGuest();
      this.$refs.signaturePad.clear();
    },
    onSigned: function(event) {
      this.currentGuest.signature = event;
      this.updateResGuest();
      this.$_gtagPlugin_trackEvent("SIGNATURE_FILLED", "PORTAL", this.guestId);
    },
    getDocumentTypeDesc: function(documentTypeId) {
      return this.documentTypeService.getDocumentTypeDesc(documentTypeId);
    },
    openWarningBackScreenModal() {
      this.showWarningBackScreenModal = true;
    },
    goBack() {
      this.restoreBackupGuest();
      this.$setIsBackingStep(true);
      this.$setCurrentMobileStep(1);
    },
    nextWithoutSendData() {
      localStorage.removeItem("selectedGuestId");
      localStorage.removeItem("cameFromMultGuest");
      if (this.enableZooxpay && this.hasChargeToPayAtCheckin && this.isMaster) {
        Vue.$globalEvent.$emit("tabChange", 3);
      } else {
        Vue.$globalEvent.$emit("tabChange", 4);
      }
    },
    isNullOrAnEmptyString(str) {
      return str == null || str == "";
    },
    async next(guestId) {
      if (this.companyParams) {
        if (this.needSignature === true) {
          if (
            !this.fieldSettingsData.signatureData &&
            !this.currentGuest.signature &&
            !this.currentGuest.signatureUrl &&
            !this.currentGuest.signatureId &&
            !this.fieldSettingsData.signatureData
          ) {
            FlashMessageService.error(this.$t("SIGNATURE.MANDATORY"));
            return;
          }
        }
      }

      if (this.loading) return;

      this.reservation.guests = this.reservation.guests.map(guest =>
        guest.id === guestId ? Object.assign({}, guest) : guest
      );

      if (this.mustFinalize) {
        this.reservation.guests = this.reservation.guests.map(guest =>
          guest.id === guestId
            ? Object.assign({}, guest, { completed: true })
            : guest
        );
      }

      const guestHasFnrhId = this.reservation.guests
        .filter(x => x.fnrhId || x.completed)
        .map(g => {
          return g;
        });

      const res = this.reservationService.updateLocalGuest(guestId, {
        signature: this.currentGuest.signature,
        email: this.currentGuest.email
      });

      this.$setCurrentReservation(res);

      this.loading = true;
      localStorage.removeItem("selectedGuestId");
      localStorage.removeItem("cameFromMultGuest");

      if (this.isQualifiedGuest) {
        try {
          const resp = await this.reservationService.updateGuest(
            this.reservation.id,
            guestId,
            this.reservation,
            this.mustFinalize
          );
          if (resp && resp.statusCode === 200) {
            // updates the reservation object
            this.$setCurrentReservation(resp);
            if (guestHasFnrhId.length == this.reservation.guests.length) {
              await this.reservationService.sendWelcomeMail(resp);
            }
            // go to guests list step
            if (
              this.enableZooxpay &&
              this.hasChargeToPayAtCheckin &&
              this.isMaster
            ) {
              this.$setCurrentMobileStep(3);
            } else {
              this.$setCurrentMobileStep(4);
            }

            this.$_gtagPlugin_trackEvent(
              "GUEST_SIGNED",
              "PORTAL",
              this.guestId
            );
          }
        } catch (e) {
          this.$_gtagPlugin_trackEvent(
            "GUEST_SIGN_FAIL",
            "PORTAL",
            this.guestId
          );
        } finally {
          this.loading = false;
        }
      } else {
        this.validationModalStep = 0;
        const isChild = JSON.parse(localStorage.age).isChild;
        if (isChild) {
          await this.finalizeUnconfirmed();
        } else {
          this.showConfirmationModal = true;
        }
      }
    },
    closeValidationModal() {
      this.loading = false;
      this.showConfirmationModal = false;
    },
    closeWarningBackScreenModal() {
      this.showWarningBackScreenModal = false;
    },
    async getSelectedGuestPersonId(reservationId, guestId) {
      const resp = await this.reservationService.getPersonId(
        reservationId,
        guestId
      );

      if (resp !== "Person not found.") {
        this.guestComunicationOptions = resp.contactInfoList;
        return resp.personId;
      }
      return -1;
    },
    async saveGuestToGeneratePersonId() {
      this.reservation = this.reservationService.updateLocalGuest(
        this.guestId,
        {
          allowCreatePerson: true
        }
      );
      try {
        this.showValidationModal = false;
        const reservation = await this.reservationService.updateGuest(
          this.reservation.id,
          this.guestId,
          this.reservation,
          this.mustFinalize
        );

        const currentGuest = reservation.guests.find(
          g => g.id === this.guestId
        );

        if (currentGuest.allowCreatePerson === false) {
          this.$setCurrentReservation(reservation);
          await this.reservationService.sendWelcomeMail(reservation);
          this.finalizeWithouValidation();
        } else {
          const personId = await this.getSelectedGuestPersonId(
            this.reservation.id,
            this.guestId
          );

          if (personId != null && personId !== -1) {
            let guestIndex = reservation.guests.findIndex(
              x => x.id === this.guestId
            );
            reservation.guests[guestIndex]["personId"] = personId;
          }

          this.$setCurrentReservation(reservation);
          this.validationModalStep = 1;
          this.showConfirmationModal = true;
        }
      } catch (e) {
        console.error(e);
        if (e.status === 409) {
          FlashMessageService.error(
            this.$t("GLOBAL_ERROR.PERSON_DATA_ALREADY_EXISTS")
          );
        }
      } finally {
        this.loading = false;
      }
    },
    async finalizeUnconfirmed() {
      try {
        const resp = await this.reservationService.updateGuest(
          this.reservation.id,
          this.guestId,
          this.reservation,
          this.mustFinalize
        );

        if (resp && resp.statusCode === 200) {
          this.$setCurrentReservation(resp);
          await this.reservationService.sendWelcomeMail(resp);
          this.finalizeWithouValidation();
        }
      } finally {
        this.loading = false;
      }
    },
    finalizeWithouValidation() {
      if (this.enableZooxpay && this.hasChargeToPayAtCheckin && this.isMaster) {
        this.$setCurrentMobileStep(3);
      } else {
        this.$setCurrentMobileStep(4);
      }

      this.$_gtagPlugin_trackEvent("GUEST_SIGNED", "PORTAL", this.guestId);
    },
    finalizeConfirmed() {},
    updateResGuest() {
      const res = this.reservationService.updateLocalGuest(
        this.currentGuest.id,
        { ...this.currentGuest }
      );

      this.$setCurrentReservation(res);

      for (let x = 0; x < this.reservation.guests; x++) {
        if (this.reservation.guests[x].id === this.currentGuest.id) {
          this.reservation.guests[x] = this.currentGuest;
        }
      }
    },
    restoreBackupGuest() {
      const res = this.reservationService.updateLocalGuest(
        this.currentGuest.id,
        { ...this.backupGuest }
      );

      this.$setCurrentGuest({ ...this.backupGuest });
      this.$setCurrentReservation(res);

      for (let x = 0; x < this.reservation.guests; x++) {
        if (this.reservation.guests[x].id === this.backupGuest.id) {
          this.reservation.guests[x] = this.backupGuest;
        }
      }
    },
    confirmEditGuest() {
      this.canShow = true;
      this.hasClickedEditButton = true;
      this.updateResGuest();
    },
    ddiInput(val) {
      this.currentGuest.ddi = val.phoneDial;
      this.currentGuest.phoneMask = val.phoneMask;
      this.currentGuest.phoneCountryCode = val.code;
    },
    numberInput(val) {
      const lastIndexMobileCityCode = this.getLastIndexDdd(
        this.currentGuest.phoneMask
      );
      this.currentGuest.ddd = val
        ? val.substring(0, lastIndexMobileCityCode)
        : "";
      this.currentGuest.phoneNumber = val
        ? val.substring(lastIndexMobileCityCode)
        : "";
    },
    ddiInputMobile(val) {
      this.currentGuest.mobileCountryCode = val.phoneDial;
      this.currentGuest.mobileCountryCode = val.phoneDial;
      this.currentGuest.mobilePhoneMask = val.mobilePhoneMask;
      this.currentGuest.mobilePhoneCountryCode = val.code;
    },
    onMobileMaskSelect(mask) {
      this.currentGuest.mobilePhoneMask = mask;
      for (let x in this.currentReservation.guests) {
        if (this.currentReservation.guests[x].id === this.currentGuest.id) {
          this.currentReservation.guests[x].mobilePhoneMask = mask;
          break;
        }
      }
    },
    onMaskSelect(mask) {
      this.currentGuest.phoneMask = mask;
      for (let x in this.currentReservation.guests) {
        if (this.currentReservation.guests[x].id === this.currentGuest.id) {
          this.currentReservation.guests[x].phoneMask = mask;
          break;
        }
      }
    },
    numberInputMobile(val) {
      const lastIndexMobileCityCode = this.getLastIndexDdd(
        this.currentGuest.mobilePhoneMask
      );
      this.currentGuest.mobilePhoneNumber = val;
      this.currentGuest.mobilePhoneNumber = val
        ? val.substring(lastIndexMobileCityCode)
        : "";
      this.currentGuest.mobileCityCode = val
        ? val.substring(0, lastIndexMobileCityCode)
        : "";
      this.currentGuest.mobileCityCode = val
        ? val.substring(0, lastIndexMobileCityCode)
        : "";
    },
    getLastIndexDdd(mask) {
      /* eslint-disable no-useless-escape */
      mask = mask || "";

      const maskDdd = mask
        ? mask
            .replace(/[\(|\)]/g, "")
            .replace(/[-|\.|\/]/g, " ")
            .split(" ")[0]
        : "";
      if (mask.length === maskDdd.length) {
        return 0;
      }
      return maskDdd.length >= 4 ? maskDdd.length - 2 : maskDdd.length;
    },
    handlerClose: function() {
      this.reservationService.sendWelcomeMail().catch(e => console.error(e));
    }
  }
};
